import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { ITheme } from '@uifabric/styling';
import RequiredAttendeeRow from 'owa-calendar-meeting-forms-common-view/lib/components/Attendees/RequiredAttendeeRow';

const styles = require('./QuickComposeAttendeeRows.scss');

export interface QuickComposeAttendeeRowsProps {
    colorScheme: ColorScheme;
    theme: ITheme;
    showAvailability?: boolean;
}

const QuickComposeAttendeeRows: React.FunctionComponent<QuickComposeAttendeeRowsProps> = props => {
    const { colorScheme, theme, showAvailability } = props;

    return (
        <RequiredAttendeeRow
            colorScheme={colorScheme}
            theme={theme}
            showAvailability={showAvailability}
            iconContainerClassName={styles.quickComposeIcon}
            className={styles.composeAttendeeRow}
        />
    );
};

export default observer(QuickComposeAttendeeRows);
